export default __webpack_public_path__ + "media/hi-there-bg-mobile.0fc28720.png";